/**
 * 批量导入部门翻译 - 英文
 * Batch Import Departments Translations - English
 */
export const batchImportDeptEn = {
  // Dialog
  title: 'Batch Import Departments',
  dialogTitle: 'Batch Import Departments',
  
  // Steps
  steps: {
    title: 'Import Steps',
    step1: 'Download department import template',
    step2: 'Fill in department information according to template format',
    step3: 'Upload the completed file',
    step4: 'Confirm and submit import',
  },
  
  // Template related
  template: {
    title: 'Template Instructions',
    downloadBtn: 'Download Template',
    downloading: 'Downloading...',
    downloaded: 'Template Downloaded',
    fields: {
      name: 'Department Name',
      nameDesc: 'Required, the name of the department',
      code: 'Department Code',
      codeDesc: 'Required, unique identifier, uppercase letters, numbers, underscores or hyphens',
      parentCode: 'Parent Code',
      parentCodeDesc: 'Optional, fill in the parent department code',
      description: 'Description',
      descriptionDesc: 'Optional, detailed description of the department',
      order: 'Order',
      orderDesc: 'Optional, number for sorting',
    },
    autoCodeTip: '💡 Tip: Leave parent code empty for top-level department',
  },

  // Upload related
  upload: {
    title: 'Upload File',
    required: 'Upload File *',
    placeholder: 'Click to select file or drag file here',
    reselect: 'Click to reselect file',
    formatHint: 'Supports .xlsx, .xls, .csv formats',
    parsing: 'Parsing...',
    parseSuccess: 'File parsed successfully, {count} valid records',
    parseWarning: 'File parsed with {count} invalid records',
    parseFailed: 'Failed to parse file, please check file format',
  },

  // Table
  table: {
    deptName: 'Department Name',
    deptCode: 'Department Code',
    parentCode: 'Parent Code',
    description: 'Description',
    order: 'Order',
    error: 'Error',
    noParent: 'Top Level',
  },

  // Data validation
  validation: {
    validData: 'Valid Data',
    invalidData: 'Invalid Data',
    dataCount: '{count} items',
    errorReasons: {
      missingRequired: 'Missing required fields',
      invalidCodeFormat: 'Invalid code format',
      parentNotFound: 'Parent department not found: {code}',
    },
  },

  // Actions
  actions: {
    cancel: 'Cancel',
    confirm: 'Start Import',
    confirmWithCount: 'Start Import ({count} items)',
    importing: 'Importing...',
  },

  // Messages
  messages: {
    noValidData: 'No valid data to import',
    importSuccess: 'Successfully imported {count} departments',
    importPartial: 'Import completed: {success} succeeded, {failed} failed',
    importFailed: 'Import failed',
  },

  // Import related
  import: {
    selectFile: 'Please select a file',
    selectOrg: 'Please select an organization first',
    importSuccess: 'Import successful',
    importFailed: 'Import failed',
    developing: 'Feature in development',
    noValidData: 'No valid data to import',
  },
};

